import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalVariables } from 'src/app/GlobalVariables';
import { GTCRequisitionservice } from 'src/app/Shared/GTCRequisition.service';
import { CommonService } from 'src/app/Shared/common.service';
@Component({
  selector: 'app-tqapproval',
  templateUrl: './tqapproval.component.html',
  styleUrls: ['./tqapproval.component.css']
})
export class TQApprovalComponent implements OnInit{

  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] =
  ['GTCNumber','EntityName','EngPartnerName','EngPartnerLocation','EngManagerName','StatusName','CreatedBy','CreatedOn'];
  statusList : any;
  pageIndex: number = 1;
  length: number = 0;
  IsTQTeam: any;
  IsLoadingResults: any;
  IsTQLeader: any;
  totalPage: number = 0;
  ReqDatefrom: any=undefined;
  ReqDateTo:  any=undefined;
  SearchRequistion!: FormGroup;
  entityNameList : any;
  fminDate!: Date;
  requestId: any;
  toDate!: Date;
  dataSource: any =[];
   @ViewChild(MatPaginator) paginator!: MatPaginator;
   @ViewChild(MatSort) sort!: MatSort;
  constructor(private http: HttpClient,
     private fb: FormBuilder, 
     private _router: Router, 
     private activatedRoute: ActivatedRoute,
     public _global: GlobalVariables,
     private _gtcService: GTCRequisitionservice,
     private _commonService: CommonService){
    this.SearchRequistion = this.fb.group({
      GTCID:[],
      GTCNumber: [],
      FirmId:[],
      EngManagerName:[],
      EngPartnerName:[],
      FromDate:[null],
      ToDate:[null],
      RecordStatus:[],
      PageNumber: (this._global.pageIndex),
      PageSize: (this._global.RecordSize)

  });
  }
  ngOnInit(){

    this.requestId  = this.activatedRoute.snapshot.paramMap.get('ID');


    this._commonService.BindDropDown('FirmType').subscribe(result => {
      this.entityNameList = result;
      //this.GetAllGTCData();
    });


        this.SearchPRList();
  


  }
  SearchPRList() {
    this.pageIndex = 0;
    this.length = 0;
    this.totalPage = 0;

    this.GetAllGTCData();
    
}

  onSubmit(){
      this._global.pageIndex = 1;
      this._global.length = 0;
      this._global.totalPage = 0;
      this.GetAllGTCData();
  }
  Exit(){
    this._router.navigate(['/home']);
  }
  ResetData(){
      if (confirm('Are you sure want to reset from the form.')) {
        this.SearchRequistion.reset();
       this.GetResult();
      }
  }
  onGetDataResult(data:any){
    if(this.requestId == 3){
    this._router.navigate(['home/createRequistion/edit/' + data.RequestEntityId]);
    }
    else{
    this._router.navigate(['home/TQLeaderDetailsView/' + data.RequestEntityId]);
    }
  }
  GetResult(){
    this._global.pageIndex = 0;
    this._global.length = 0;
    this._global.totalPage = 0;
    this.GetAllGTCData();
  }
  getFormControls(controlName : any){
    return this.SearchRequistion.controls[controlName];
  }
  orgValueChange(value :any){

  }
  GetAllGTCData(){
    this.IsLoadingResults = true;
    if(this.requestId == 3){
      this.SearchRequistion.controls['RecordStatus'].setValue(2);
    }
    if(this.requestId == 4){
      this.SearchRequistion.controls['RecordStatus'].setValue(3);
    }
    this.SearchRequistion.controls['PageNumber'].setValue(this._global.pageIndex + 1);
    this.SearchRequistion.controls['PageSize'].setValue(this._global.RecordSize);
    // let ReqDate = this.SearchRequistion.controls['FromDate'].value;
    // this.ReqDatefrom = (ReqDate == undefined || ReqDate == null) ? null : ReqDate.toDateString();
    // this.SearchRequistion.controls['FromDate'].patchValue(this.ReqDatefrom);
    // let ReqToDate = this.SearchRequistion.controls['ToDate'].value;
    // this.ReqDateTo = (ReqToDate == undefined || ReqToDate== null) ? null : ReqToDate.toDateString();
    // this.SearchRequistion.controls['ToDate'].patchValue(this.ReqDateTo);

    // sessionStorage.setItem('ViewGTCRequisition', JSON.stringify(this.SearchRequistion.getRawValue()));

    this._gtcService.GetAllFDetailsOfGTCForm(this.SearchRequistion.value, false).subscribe((result:any) => {
      this.IsLoadingResults = false;
    
      this.dataSource = result;
      if (this.dataSource != null && this.dataSource.length > 0) {
        this._global.length = this.dataSource[0].Totalrecordcount;
        this._global.totalPage = Math.ceil(this._global.length / this._global.RecordSize);
      } else {
        this._global.length = 0;
        this._global.pageIndex = 1;
        this._global.totalPage = 0;
      }
    });
  }
  GoToPage() {
    if (this.pageIndex <= 0) { this.pageIndex = 1; }
    else if (this.pageIndex > this.totalPage) { this.pageIndex = this.totalPage; }
    this.GetAllGTCData();
}
onPaginateChange(event: any) {
  this._global.pageIndex = event.pageIndex;
    this._global.RecordSize = event.pageSize;
  this.GetAllGTCData();
}
}
